var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.78 20.7199C23.9207 20.5793 23.9998 20.3887 24 20.1899V19.8099C23.9977 19.6114 23.9189 19.4216 23.78 19.2799L18.64 14.1499C18.5461 14.0552 18.4183 14.002 18.285 14.002C18.1517 14.002 18.0239 14.0552 17.93 14.1499L17.22 14.8599C17.1259 14.952 17.0729 15.0782 17.0729 15.2099C17.0729 15.3415 17.1259 15.4677 17.22 15.5599L21.67 19.9999L17.22 24.4399C17.1253 24.5337 17.0721 24.6615 17.0721 24.7949C17.0721 24.9282 17.1253 25.056 17.22 25.1499L17.93 25.8499C18.0239 25.9445 18.1517 25.9978 18.285 25.9978C18.4183 25.9978 18.5461 25.9445 18.64 25.8499L23.78 20.7199Z",
    fill: "#0E9384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardRightArrow);
export default __webpack_public_path__ + "static/media/Leaderboard_Right_Arrow.3de5b661ef25bd01286f87b2941fe5ee.svg";
export { ForwardRef as ReactComponent };